import React from 'react';
import Header from '../../components/ui/Header';
import ExecutiveBoardSection from './components/ExecutiveBoardSection';
import MemberDirectory from './components/MemberDirectory';
import AlumniSection from './components/AlumniSection';
import MemberSpotlight from './components/MemberSpotlight';
import DiversityStats from './components/DiversityStats';
import ProfessionalDevelopment from './components/ProfessionalDevelopment';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import Footer from 'components/ui/Footer';

const MembersLeadershipShowcase = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 hero-gradient text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center">
            <div className="inline-flex items-center bg-white/20 rounded-full px-4 py-2 mb-6">
              <Icon name="Users" size={20} className="mr-2" />
              <span className="text-sm font-medium">150+ Active Members</span>
            </div>
            
            <h1 className="text-4xl lg:text-6xl font-bold mb-6 text-shadow">
              Meet Our
              <span className="block text-secondary">Leadership Community</span>
            </h1>
            
            <p className="text-xl lg:text-2xl text-white/90 mb-8 max-w-4xl mx-auto leading-relaxed">
              Discover the diverse professionals, visionary leaders, and passionate changemakers 
              who drive Leo Circle Colombo's mission of service excellence and community impact.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                variant="secondary" 
                size="lg"
                className="achievement-gradient text-white hover:opacity-90"
              >
                <Icon name="UserPlus" size={20} className="mr-2" />
                Join Our Community
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                className="border-white/30 text-white hover:bg-white/10"
              >
                <Icon name="Download" size={20} className="mr-2" />
                Member Directory
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Executive Board Section */}
      <ExecutiveBoardSection />

      {/* Member Spotlight */}
      <MemberSpotlight />

      {/* Member Directory */}
      <MemberDirectory />

      {/* Diversity Statistics */}
      <DiversityStats />

      {/* Professional Development */}
      <ProfessionalDevelopment />

      {/* Alumni Section */}
      <AlumniSection />

      {/* Membership CTA Section */}
      <section className="py-16 bg-background">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <div className="bg-card rounded-2xl p-8 lg:p-12 card-shadow">
            <div className="w-16 h-16 hero-gradient rounded-full flex items-center justify-center mx-auto mb-6">
              <Icon name="Handshake" size={32} className="text-white" />
            </div>
            
            <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-6">
              Ready to Join Our Leadership Journey?
            </h2>
            
            <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
              Become part of a community where professional growth meets purposeful service. 
              Connect with like-minded leaders and make a lasting impact on Colombo's future.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                variant="default" 
                size="lg"
                className="hero-gradient hover:opacity-90"
              >
                <Icon name="ArrowRight" size={20} className="mr-2" />
                Start Your Application
              </Button>
              <Button variant="outline" size="lg">
                <Icon name="Calendar" size={20} className="mr-2" />
                Attend a Meeting
              </Button>
            </div>
            
            <div className="mt-8 pt-8 border-t border-border">
              <div className="flex items-center justify-center space-x-8 text-sm text-muted-foreground">
                <div className="flex items-center">
                  <Icon name="Clock" size={16} className="mr-2 text-primary" />
                  <span>Monthly meetings</span>
                </div>
                <div className="flex items-center">
                  <Icon name="MapPin" size={16} className="mr-2 text-primary" />
                  <span>Colombo locations</span>
                </div>
                <div className="flex items-center">
                  <Icon name="Users" size={16} className="mr-2 text-primary" />
                  <span>All backgrounds welcome</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
      
    </div>
  );
};

export default MembersLeadershipShowcase;